import React, { useEffect } from "react";
import {
  CognitoUserPool,
} from "amazon-cognito-identity-js";
import { useApp } from "../../../services/app-context";

import { getLoggerRef } from "../../../integrations/logger/logger-bridge";
import { OktaLogin } from "./OktaLogin";
import { Login } from "./Login";
import { isSSOEnabled } from "../../../integrations/posthog/featureFlags";

export function LoginApp() {
  const { tenantProfile } = useApp();

  useEffect(() => {
    if (tenantProfile) {
      var poolData = {
        UserPoolId: tenantProfile.user_pool_id, // Your user pool id here
        ClientId: tenantProfile.user_pool_client_id, // Your client id here
      };
      var userPool = new CognitoUserPool(poolData);
      var cognitoUser = userPool.getCurrentUser();
      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            // A stale stored session is not actionable here (the user is already on the
            // login page and just signs in again), so log only.
            getLoggerRef()?.warn("Login page: stored Cognito session check failed", {
              errorMessage: err.message,
            });
            return;
          }

          // Instantiate aws sdk service objects now that the credentials have been updated.
          // example: var s3 = new AWS.S3();
        });
      }
    }
  }, [tenantProfile]);

  if (!tenantProfile) {
    return null;
  }

  if (tenantProfile?.sso_redirect_url && isSSOEnabled()) {
    return <OktaLogin />;
  }

  return (
    <Login />
  );
}
